export default __webpack_public_path__ + "static/media/golive.9e075bab.png";